import { Button } from "antd";
import "./index.less";
export default Button;